import { get } from 'lodash';

// local dependencies
import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { getStore } from 'store';
import { REDUCER } from 'constants/entity-names';

// get store
const store = getStore();

/*************************************************************/

/**
 * @type {class}
 * @desc CallDispositionCloseCall defines an HTTP service interface to send HTTP network requests.
 * @example
 * import { CallDispositionCloseCallService } from 'services/callDispositionCloseCall';
 *
 * // create service instance and send/cancel request
 * const CallDispositionCloseCallService = new CallDispositionCloseCallService();
 * const result = await CallDispositionCloseCallService.fetchData( '<user-id>' ); // fetch data
 * CallDispositionCloseCallService.cancel(); // cancel an active request
 */
export class CallDispositionCloseCallService extends HttpService {

    // fetch end call widget data
    async fetchComponentData( { url = {}, data = {} } = {} ) {

        // get ongoing call info from the redux store
        const callId = get( store.getState()[ REDUCER.CALL_STATE ], 'callId', null );

        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: {
                    context: { callId, patientId: data.patientId },
                    data: data,
                }
            } );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    options: get( response, 'body.component.data.options', {} ),
                    actions: get( response, 'body.component.structure.actions', [] ),
                },
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }

    // submit call close request
    async closeCall( { url = {}, data = {}, patientId } = {} ) {

        // get ongoing call info from the redux store
        const callId = get( store.getState()[ REDUCER.CALL_STATE ], 'callId', null );
        const callType = get( store.getState()[ REDUCER.CALL_STATE ], 'callType', null );

        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: {
                    context: { callId, callType, patientId: patientId },
                    data: data,
                }
            } );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: null,
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }
}
